<template>
    <div class="view pa24">
  
      <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
        :close-on-click-modal="false" :before-close="closeDialog">
        <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="130px" class="ruleForm">
          <el-form-item label="所属父级" prop="parentName">
            <el-select class="main-select-tree" ref="selectTree" clearable @clear="setValueNull" v-model="parentName"
              style="width: 300px;" name='option 1'>
              <el-option v-for="(item, index) in optionData(classList)" :label="item.label" :value="item.id" :key="index"
                style="display: none;" />
              <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps'
                highlight-current @node-click="handleNodeClick" :expand-on-click-node="expandOnClickNode" :lazy="true"
                :load="load" collapse-tags />
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="unit">
            <el-select v-model="ruleForm.unit" placeholder="请选择">
              <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 原材料类型管理 -->
          <el-form-item label="所属类型" prop="materialType">
            <el-select v-model="ruleForm.materialTypeId" placeholder="请选择所属类型">
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格" prop="specName">
            <el-input v-model="ruleForm.specName"></el-input>
          </el-form-item>
          <el-form-item label="型号" prop="modelNo">
            <el-input v-model="ruleForm.modelNo"></el-input>
          </el-form-item>
          <el-form-item label="存货编码" prop="inventCode">
            <el-input v-model="ruleForm.inventCode"></el-input>
          </el-form-item>
          <!-- <el-form-item label="截面积" prop="sectionalArea">
            <el-input v-model="ruleForm.sectionalArea"></el-input>
          </el-form-item> -->
          <!-- 宽度 -->
          <el-form-item label="宽度(mm)" prop="width">
            <el-input v-model="ruleForm.width"></el-input>
          </el-form-item>
          <!-- 厚度 -->
          <el-form-item label="厚度(mm)" prop="thickness">
            <el-input v-model="ruleForm.thickness"></el-input>
          </el-form-item>
          <el-form-item label="长度(mm)" prop="length">
            <el-input v-model="ruleForm.length"></el-input>
          </el-form-item>
          <el-form-item label="密度" prop="density">
            <el-input v-model="ruleForm.density"></el-input>
          </el-form-item>
          <el-form-item label="库存预警数" prop="stockWarningNum">
            <el-input-number v-model="ruleForm.stockWarningNum"></el-input-number>
          </el-form-item>
          <el-form-item label="是否需要备件" prop="needSpare">
            <el-radio-group v-model="ruleForm.needSpare" size="small">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否提醒SCM系统" prop="isRemindScm" v-if="ruleForm.needSpare">
            <el-radio-group v-model="ruleForm.isRemindScm" size="small">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否提醒APS系统" prop="isRemindAps" v-if="ruleForm.needSpare">
            <el-radio-group v-model="ruleForm.isRemindAps" size="small">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序">
            <el-input type="number" v-model="ruleForm.sort"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button class="btncss" @click="confirmAddCustomer">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
    import { addPageClass, pageClassList } from '@/api/customPageClass.js'
    import { selectAllMaterialType } from '@/api/storeMaterialType.js'
    import { selectAllUnit } from '@/api/storeUnit.js'
    export default {
      name: "addPageClass",
      components: {
        // BaiduMap,
      },
      props: [],
  
      data() {
        return {
          typeList: [],
          provinces: [],
          classType: null,
          dialogVisible: false,
          title: '添加原材料',
  
          parentId: '',
          parentName: '顶级',
          treeProps: {
            children: 'children',
            label: 'name'
          },
          expandOnClickNode: false,
          unitList: [],
          ruleForm: {
            name: '',
            sort: 999,
            parentId: null,
            busName: '',
            goodsCode: '',
            specCode: '',
            specName: '',
            classType: 1,
            sectionalArea: 0,
            length: 0,
            density: 0,
            stockWarningNum: '',
            partNumber: '',
            isRemindScm: false,
            isRemindAps: false,
            productQualification: '',
            isNeedOutsourcing: false,
            needSpare: false,
            materialTypeId: '',
            inventCode: '',
            modelNo: '',
            unit: '',
            width: 0,
            thickness: 0,
          },
          rules: {
            name: [
              { required: true, message: '请输入类别名称', trigger: 'blur' },
            ],
            busName: [
              { required: true, message: '请输入商家名称', trigger: 'blur' },
            ],
            goodsCode: [
              { required: true, message: '请输入货品编码', trigger: 'blur' },
            ],
            specCode: [
              { required: true, message: '请输入规格码', trigger: 'blur' },
            ],
            specName: [
              { required: true, message: '请输入规格名称', trigger: 'blur' },
            ],
            phone: [
              { required: true, message: '请输入联系电话', trigger: 'blur' },
              {
                type: 'number',
                message: '手机号格式不正确',
                trigger: 'blur',
                transform(value) {
                  var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
                  if (!phonereg.test(value)) {
                    return false
                  } else {
                    return Number(value)
                  }
                }
              }
            ]
  
          },
          type: 'add',
          id: '',
          classList: [{ value: 0, label: 'fadsfs' }],
        };
      },
      onShow() {
      },
      mounted() {
        this.getMaterialType()
        this.getUnit()
      },
      methods: {
        getUnit() {
          selectAllUnit().then(res => {
            this.unitList = res.data
          })
        },
        load(node, resolve) {
          if ('顶级' == node.data.name) {
            return resolve(node.data.children)
          } else {
            let params = {
              noPage: true,
              name: this.name,
              classType: 1,
              status: this.storeStatus,
              parentId: node.data.id
            }
            pageClassList(params).then(res => {
              return resolve(res.data.list)
            })
          }
        },
        getMaterialType() {
          selectAllMaterialType().then(res => {
            if (res.data) {
              this.typeList = res.data
            }
          })
        },
        handleCheckChange(node, list) {
          this.ruleForm.parentId = node.id;
          //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点
          if (list.checkedKeys.length == 2) {
            //单选实现
            this.$refs.selectTree.setCheckedKeys([node.id]);
          }
        },
        getAllClass() {
          let params = {
            pageNum: 1,
            pageSize: 999,
            classType: 1,
          }
          pageClassList(params).then(res => {
            this.classList = [{ id: '', name: '顶级', children: res.data.list }]
          })
        },
        openDialog(type, data, classType) {
          this.getAllClass()
          this.dialogVisible = true
          let v = this
          v.classType = classType
          if (type === 'add') {
            // 滞空
            this.ruleForm = {
              length: 0,
              density: 0,
              width: 0,
              thickness: 0,
            }
            this.title = '添加类别'
            this.type = 'add'
            this.id = ''
            this.$refs.dealerRuleForm.resetFields();
            this.ruleForm.name = ''
            this.ruleForm.sectionalArea = ''
            this.ruleForm.density = ''
          }
        },
        handleNodeClick(node) {
          this.ruleForm.parentId = node.id
          this.parentName = node.name
          this.$refs.selectTree.blur();
        },
        setValueNull() {
          this.ruleForm.parentId = '';
          this.parentName = ''
        },
        optionData(array, result = []) {
          array.forEach(item => {
            result.push({
              label: item.name,
              value: item.id
            })
            if (item.children && item.children.length !== 0) {
              this.optionData(item.children, result)
            }
          })
          return JSON.parse(JSON.stringify(result))
        },
        closeDialog() {
          this.dialogVisible = false
          this.resetForm()
        },
        resetForm() {
          this.$refs.dealerRuleForm.resetFields();
        },
        confirmAddCustomer() {
          this.$refs.dealerRuleForm.validate((valid) => {
            if (valid) {
              let params = {
                name: this.ruleForm.name,
                sort: this.ruleForm.sort,
                type: 0,
                parentId: this.ruleForm.parentId,
                busName: this.ruleForm.busName,
                goodsCode: this.ruleForm.goodsCode,
                specCode: this.ruleForm.specCode,
                specName: this.ruleForm.specName,
                classType: 1,
                sectionalArea: this.ruleForm.sectionalArea,
                unit: this.ruleForm.unit,
                length: this.ruleForm.length,
                width: this.ruleForm.width,
                thickness: this.ruleForm.thickness,
                density: this.ruleForm.density,
                materialTypeId: this.ruleForm.materialTypeId,
                stockWarningNum: this.ruleForm.stockWarningNum,
                partNumber: this.ruleForm.partNumber,
                isRemindScm: this.ruleForm.isRemindScm,
                isRemindAps: this.ruleForm.isRemindAps,
                productQualification: this.ruleForm.productQualification,
                isNeedOutsourcing: this.ruleForm.isNeedOutsourcing,
                needSpare: this.ruleForm.needSpare,
                modelNo: this.ruleForm.modelNo,
                inventCode: this.ruleForm.inventCode
              }
              if (this.type === 'edit') {
                params.id = this.id
                addPageClass(params).then(res => {
                  if (res.code === 200) {
                    this.$message({
                      type: "success",
                      message: "操作成功",
                    });
                    this.closeDialog()
                    this.$emit('getList')
                  }
                })
              } else {
                let obj = JSON.parse(JSON.stringify(params))

                addPageClass(params).then(res => {
                  const {name, id} = res.data
                  if (res.code === 200) {
                    this.$message({
                      type: "success",
                      message: "操作成功",
                    });
  
                    this.closeDialog()
                    this.$emit('getList', {...obj, id, name})
                  }
                })
              }
            }
          })
        },
        // 回显
        getData(data) {
          // this.ruleForm={}
          // this.ruleForm = data
          // this.parentName = data.name
        },
      },
  
  
    };
  </script>
  
  <style lang="scss" scoped>
    .ml10 {
      margin-left: 10 rpx;
    }
  </style>